import React from 'react';

export interface AlertMessageProps {
    message: React.ReactNode;
    html?: boolean;
}

const AlertMessage: React.FC<AlertMessageProps> = ({message, html}) => {
    if (typeof message === 'string' && html) {
        return <div dangerouslySetInnerHTML={{__html: message}} />;
    }
    return <>{message}</>;
};

export default AlertMessage;
